<template>
  <div>
    <div class="p-grid p-justify-center" style="padding-top: 50px">
      <div class="p-col-12 p-justify-center">
        <center>
          <h1>Anmeldung fehlgeschlagen</h1>
        </center>
      </div>
      <div class="p-col-12 p-justify-center">
        <center>
          Die Anwendung ist für Kerberos Authentifizierung konfiguriert welche fehlgeschlagen ist.<br>
          Wenden Sie sich an den Zuständigen.
        </center>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "KerberosLogin"
}
</script>

<style scoped>

</style>